import { render, staticRenderFns } from "./qr-card.vue?vue&type=template&id=88845488&scoped=true"
import script from "./qr-card.vue?vue&type=script&lang=js"
export * from "./qr-card.vue?vue&type=script&lang=js"
import style0 from "./qr-card.vue?vue&type=style&index=0&id=88845488&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88845488",
  null
  
)

export default component.exports